module.exports = require('./helpers/bundle-url').getBundleURL('8zyGl') + "logo-dark.eefe0b7f.svg";